export const applianceIdTm6 = 207;
export const applianceIdGeOven = 174;
